import React, { useEffect } from "react";
import { Col, Row } from "antd";
import Widget from "../../../../../components/Widget";
import style from "./LeftWidget.module.scss";
import { getRightAnswerCount } from "../../../../homework/component/Rows/utils";
import _ from "underscore";
import GoBackButton from "pages/homework/component/goBackButton";

// import moment from 'moment'

interface ILeftWidgetProps {
    courseName: string;
    stuName: string;
    homeworkTime: string;
    list: any[];
}

export default function LeftWidget({
    courseName,
    stuName,
    homeworkTime,
    list
}: ILeftWidgetProps) {
    // const [infoList, setInfoList] = useState<any[]>([])

    useEffect(() => {
        let data: any[] = _.chain(list)
            .groupBy("type")
            .map((list, key: string) => {
                let count, score;
                if (key === "4") {
                    count = "-";
                    score = _.reduce(
                        list,
                        (memo, item) =>
                            parseFloat(item.markScore)
                                ? memo + parseFloat(item.markScore)
                                : memo,
                        0
                    );
                } else {
                    let data = getRightAnswerCount(list, key);
                    count = data.count;
                    score = data.score;
                }
                return {
                    type: key,
                    all: list.length,
                    correct: count,
                    score: score
                };
            })
            .value();
        // setInfoList(data)
    }, [list]);

    return (
        <Widget title="判卷" bodyPadding extraTools={<GoBackButton />}>
            <div className={style.root}>
                <Row className={style.item}>
                    <Col span={24} className={style.label}>
                        课程：{courseName}
                    </Col>
                </Row>
                <Row className={style.item}>
                    <Col span={24}>
                        <span className={style.label}>姓名：</span>
                        {stuName}
                    </Col>
                </Row>
                <Row className={style.item}>
                    <Col span={24}>
                        <span>时间：</span>
                        {homeworkTime}
                    </Col>
                </Row>
            </div>
        </Widget>
    );
}
